module.exports = __webpack_public_path__ + "static/the-bhagavad-gita-62ccdfc2cf4d8e7bf4148c6bdd2f4e8f.jpg";